<script lang="ts" setup>
import { MediaImageFragment, ParagraphImage } from '~/api/graphql/generated'

const props = defineProps<{
  entity: ParagraphImage
}>()

const image = props.entity.fieldImage?.entity as MediaImageFragment
const description = props.entity.fieldDescription?.processed
</script>

<template>
  <Section>
    <div v-animate="{ animation: 'vertical-reveal' }" class="image t-11 tl-7 ds-8">
      <Image v-if="image" :entity="image" type="teaser-single" />
      <div v-if="description" class="caption text-xsmall" v-html="description" />
    </div>
    <div class="test" />
  </Section>
</template>

<style lang="scss" scoped>
.image {
  --ml: 0;
  margin-left: var(--ml);

  @include breakpoint(tl) {
    --sides-width: max(
      0px,
      calc(min(100vw, var(--layout-max-width)) - var(--container-max-width) - 2 * var(--container-padding))
    );
    --ml: calc(((var(--sides-width) / 2) + var(--layout-padding)) * -1);
  }

  .caption {
    margin-left: calc(var(--ml) * -1);

    color: var(--c-text-light);
  }
}

.image {
  :deep(img) {
    width: 100%;
    height: auto;
  }
}
</style>
